/**
 * Stable CSS class names for E2E — Petition refund list V2.
 */
export const PRLV2 = {
    page: 'petition-refund-list-v2-page',
    breadcrumbSection: 'petition-refund-list-v2-page__breadcrumb-section',
    contentLayout: 'petition-refund-list-v2-page__content-layout',
    pdfSection: 'petition-refund-list-v2-page__pdf-section',

    actionsRow: 'petition-refund-list-v2-page__actions-row',
    downloadButtonWrap: 'petition-refund-list-v2-page__download-button-wrap',
    createPetitionButton: 'petition-refund-list-v2-page-input--button-create-petition',
    downloadBankTxtButton: 'petition-refund-list-v2-page-input--button-download-bank-txt',

    dataGridSection: 'petition-refund-list-v2-page__data-grid-section',
    dataGridWrap: 'petition-refund-list-v2-page__data-grid-wrap',

    cellDate: 'petition-refund-list-v2-page__cell-date',
    cellOrderNumber: 'petition-refund-list-v2-page__cell-order-number',
    cellRefundReason: 'petition-refund-list-v2-page__cell-refund-reason',
    cellRefundStatus: 'petition-refund-list-v2-page__cell-refund-status',
    cellDescription: 'petition-refund-list-v2-page__cell-description',
    cellAmount: 'petition-refund-list-v2-page__cell-amount',
    paymentDetailLink: 'petition-refund-list-v2-page-input--link-payment-detail',

    loadingWrap: 'petition-refund-list-v2-page__loading-wrap',
    emptyWrap: 'petition-refund-list-v2-page__empty-wrap',
} as const;

export const PRLV2_PM = {
    modalRoot: 'petition-refund-list-v2-modal',
    modalPaper: 'petition-refund-list-v2-modal__paper',
    modalTitle: 'petition-refund-list-v2-modal__title',
    modalCloseButton: 'petition-refund-list-v2-modal-input--button-close',
    modalCloseIcon: 'petition-refund-list-v2-modal__close-icon',
} as const;

export const prlv2Cls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

